import React from "react";
import styles from "../../calendar/privatePolicyPrinter/index.module.css";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";

export default function TvRemoteTermsOfService() {
	return (
		<>
			<Header />
			<div className={styles["container-A"]}>
				<div className={styles["container"]}>
					<div className={styles["title"]}>
						<h1>Terms of Service</h1>
					</div>
					<div className={styles["content"]}>
						<p>
							Welcome to TV Remote: Universal Remote, developed by StarNest
							Solution.
						</p>
						<p>
							By downloading or using the application, you agree to these Terms
							of Service. If you do not agree, please do not use the app.
						</p>
						<p>
							<strong>Use of the App</strong>
							<br />
							The app provides universal TV remote control, Wi-Fi connection,
							keyboard and voice search, screen mirroring, media casting, and
							optional Google Drive file browsing for personal and lawful use.
						</p>
						<p>
							<strong>Google Drive Access</strong>
							<br />
							Google Drive permission is optional and requested only when you
							choose to browse and cast files from your own Google Drive
							account. We do not upload, modify, delete, or share your Drive
							files with third parties.
						</p>
						<p>
							<strong>Disclaimer</strong>
							<br />
							The application is provided &quot;as is&quot; without warranties of
							any kind. StarNest Solution is not liable for damages arising from
							use of the app, including connection failures or device
							compatibility issues.
						</p>
						<p>
							<strong>Contact</strong>
							<br />
							Questions about these Terms:{" "}
							<a href="mailto:support@starnestsolution.com">
								support@starnestsolution.com
							</a>
						</p>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
}
